import HeroCarousel from './HeroCarousel';
import React from 'react';

const HeroCarouselWithProps = (props: any) => {
  return <HeroCarousel slides={props.slides} statItems={props.statItems} />;
};

export default HeroCarouselWithProps;
